var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "casino-container", attrs: { id: "casinoContainer" } },
    [
      _vm.isLoggedIn ? _c("casino-user-game-section") : _vm._e(),
      _vm._v(" "),
      _vm.allGames && _vm.allGames.groups && _vm.allGames.groups.length > 0
        ? _c(
            "div",
            { ref: "casinoLobbyRef", staticClass: "casino-wrapper" },
            [
              _vm._l(_vm.visibleGroupList, function(group, i) {
                return _c("casino-group", {
                  key: group.groupId,
                  attrs: {
                    "data-id": i + 1,
                    group: group,
                    gamesWithInfoData: _vm.allCasinoGamesWithInfoData
                  }
                })
              }),
              _vm._v(" "),
              _vm.visibleGroupList.length
                ? _c("p", {
                    class: _vm.loadMoreStatus,
                    attrs: { id: "load-more" }
                  })
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39a6fc2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a6fc2a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/CasinoLobby.vue
// module id = null
// module chunks = 